export const getCssForBackgroundImg = (url?: string) => {
  if (!url) {
    return {
      backgroundImage: null,
      backgroundSize: null,
      backgroundRepeat: null,
    };
  }
  return {
    backgroundImage: `url("${url}")`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };
};

export const sanitizeBackgroundImage = (backgroundImage: string) =>
  backgroundImage.replace('url("', '').replace('")', '');
